import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronRightSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M15.0605 11.9999L9.99989 6.93923L8.93923 7.99989L12.9392 11.9999L8.93923 15.9999L9.99989 17.0605L15.0605 11.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRightSmall;
